import {
  HttpDeleteRequest,
  HttpGetRequest,
  HttpPostRequest,
  HttpPutRequest,
} from "./HttpRequest.js";

export async function create(careUnitDateRange) {
  let url = "/care_unit_dates_range";
  return await HttpPostRequest(url, careUnitDateRange).then((response) => {
    return response.json();
  });
}

export async function remove(careUnitDateRangeId) {
  let url = "/care_unit_dates_range/" + careUnitDateRangeId;
  return await HttpDeleteRequest(url).then((response) => {
    return response.json();
  });
}

export async function update(id, careUnitDateRange) {
  let url = "/care_unit_dates_range/" + id;
  return await HttpPutRequest(url, careUnitDateRange).then((response) => {
    return response.json();
  });
}

export async function getOne(careUnitDateRangeId) {
  let url = "/care_unit_dates_range/" + careUnitDateRangeId;
  return await HttpGetRequest(url).then((response) => {
    return response.json();
  });
}

export async function all(payload) {
  let url = "/care_units_dates_range";
  return await HttpPostRequest(url, payload).then((response) => {
    return response.json();
  });
}
